import { Record, List } from "immutable";
import moment from "moment";
import User from "./record.user.jsx";

const CommentRecord = Record({
  id: 0,
  body: ``,
  body_formatted: ``,
  body_plain_text: ``,
  body_mode: `paragraph`,
  class: `Comment`,
  created_by_id: 0,
  created_on: 0,
  is_trashed: false,
  parent_id: 0,
  parent_type: `Task`,
  trashed_by_id: 0,
  trashed_on: 0,
  updated_by_id: 0,
  updated_on: 0,
  attachments: List(),
  reactions: List(),
  created_by_name: ``,
  created_by_email: ``,
  url_path: ``,
  pending: false,
  is_real_time: false,
  attach_uploaded_files: List(),
  drop_attached_files: List(),
  last_modification_by_email: ``,
  last_modification_by_id: 0,
  last_modification_by_name: ``,
  last_modification_on: 0,
  _error: undefined,
});

class Comment extends CommentRecord {
  /**
   * @deprecated
   */
  canEdit(user) {
    if (user instanceof User) {
      // owner can always edit the comment
      if (user.isOwner()) return true;

      // person who created comment can edit it if comment is created recently
      if (user.id === this.created_by_id) {
        return moment.utc().format(`X`) - this.created_on <= 60 * 30;
      }
    }

    return false;
  }
  /**
   * @deprecated
   */
  canDelete(user) {
    return this.canEdit(user);
  }

  isPending() {
    return !!this.pending;
  }

  hasError() {
    return !!(this._error && this._error instanceof Error);
  }
}

export default Comment;
